module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('walkthrough-stepper', {
    attrs: {
      "pageTitles": _vm.page_titles,
      "stepperTitle": "Manage Students"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var page = ref.page;

        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 0),
            expression: "page === 0"
          }],
          staticClass: "mh3 ph4 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center"
        }, [_c('i', {
          staticClass: "fas fa-user-plus fa-3x ma3"
        })]), _vm._v(" "), _c('p', {
          staticClass: "pl-subheading"
        }, [_vm._v("\n        Manage your students in the RoundTable by clicking the\n        "), _c('i', {
          staticClass: "fas fa-user-plus mh1"
        }), _vm._v(" icon. You can invite students in\n        one of three ways:\n      ")]), _vm._v(" "), _c('ol', {
          staticClass: "pl-body-1 pl3"
        }, [_c('li', {
          staticClass: "mb2"
        }, [_vm._v("\n          Select students who are already registered to your Parlay course.\n        ")]), _vm._v(" "), _c('li', {
          staticClass: "mb2"
        }, [_vm._v("\n          Invite students by sharing a private RoundTable URL.\n        ")]), _vm._v(" "), _c('li', {
          staticClass: "mb2"
        }, [_vm._v("\n          Share the invitation URL with your Google Classroom.\n        ")])])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 1),
            expression: "page === 1"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center"
        }, [_c('i', {
          staticClass: "fas fa-eye fa-3x ma3"
        })]), _vm._v(" "), _c('div', {
          staticClass: "pl-subheading"
        }, [_vm._v("\n        When "), _c('span', {
          staticClass: "italics"
        }, [_vm._v("Anonymous Mode")]), _vm._v(" is turned on the\n        teacher can use this button to switch between the students secret\n        identities and real ones.\n      ")])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-10b8ea07!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/pages/onlineWalkthroughStudentlist.vue
// module id = 1333
// module chunks = 61